import { Dialog } from '@material-ui/core';
import type { Version } from 'interfaces/version';
import { FunctionComponent, useRef } from 'react';
import dialogStyles from 'styles/dialog';
import { sendMessage, useMessageListener } from 'utils/alphaOmega';

interface AoVersionEditorIframeI {
  show: boolean;
  version?: { title?: string; slug?: string; content?: string };
  showCallback: (show: boolean) => void;
  submitCallback: (version: Version) => void;
}

export const AoVersionEditorIframe: FunctionComponent<AoVersionEditorIframeI> =
  ({ show, version, showCallback, submitCallback }: AoVersionEditorIframeI) => {
    const classes = dialogStyles();
    const aoHost = process.env.REACT_APP_AO_URL || '';

    const ref = useRef<HTMLIFrameElement>(null);

    useMessageListener('VersionEditor', {
      size: ({ height }) => {
        if (show && ref.current) {
          ref.current.style.height = `${height}px`;
        }
      },
      show: open => showCallback(open),
      submit: v => show && submitCallback(v),
      ...(version && { mounted: () => sendMessage(ref, 'version', version) })
    });

    return show ? (
      <Dialog
        fullWidth
        maxWidth="sm"
        aria-labelledby="simple-dialog-title"
        open
        classes={{ paper: classes.basic }}
      >
        <iframe
          title="AO-VersionEditor"
          ref={ref}
          src={`${aoHost}/embed/review`}
          style={{
            height: 688,
            width: '100%',
            border: 'none'
          }}
        />
      </Dialog>
    ) : null;
  };

AoVersionEditorIframe.defaultProps = {
  version: undefined
};
